import CrudPage from "@/components/CrudPage";

export default function Trainers() {
  return (
    <CrudPage
      title="Trainers"
      subtitle="Manage trainers and their certification across locations."
      endpoint="trainers"
      testid="trainers"
      detailBase="/trainers"
      columns={[
        { key: "full_name", label: "Name", render: (i) => <span className="font-medium">{i.full_name}</span> },
        { key: "location_name", label: "Location" },
        { key: "certification_status", label: "Certification", badge: true },
        { key: "classes_count", label: "Classes" },
        { key: "dogs_count", label: "Dogs" },
        { key: "attendance_rate", label: "Attend.", render: (i) => `${i.attendance_rate ?? 0}%` },
        { key: "status", label: "Status", badge: true },
      ]}
      fields={[
        { name: "full_name", label: "Full name" },
        { name: "email", label: "Email" },
        { name: "phone", label: "Phone" },
        { name: "location_id", label: "Assigned location", type: "select", optionsFrom: "locations", labelKey: "name" },
        { name: "certification_status", label: "Certification status", type: "select", default: "not_started", options: [
          { value: "not_started", label: "Not started" }, { value: "in_progress", label: "In progress" },
          { value: "certified", label: "Certified" }, { value: "expired", label: "Expired" },
        ] },
        { name: "specialties", label: "Specialties" },
        { name: "status", label: "Status", type: "select", default: "active", options: [
          { value: "active", label: "Active" }, { value: "inactive", label: "Inactive" },
        ] },
      ]}
    />
  );
}
